import fetch from "auth/FetchInterceptor";

const SchoolsService = {};

const schoolsEndpointPrefix = "/adminSchool";

SchoolsService.getSchools = async (adminSchoolId) =>
  await fetch(`${schoolsEndpointPrefix}/${adminSchoolId}/school`, {
    method: "GET",
  });
SchoolsService.getAllSchools = async () =>
  await fetch(`${schoolsEndpointPrefix}/schools`, {
    method: "GET",
  });
SchoolsService.getSchoolById = async (adminSchoolId, schoolId) =>
  await fetch(`${schoolsEndpointPrefix}/${adminSchoolId}/school/${schoolId}`, {
    method: "GET",
  });

SchoolsService.createSchool = async (adminSchoolId, data) =>
  await fetch({
    url: `${schoolsEndpointPrefix}/${adminSchoolId}/school/create`,
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

SchoolsService.updateSchool = async (adminSchoolId, schoolId, data) =>
  await fetch(`${schoolsEndpointPrefix}/${adminSchoolId}/school/${schoolId}`, {
    method: "PUT",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

SchoolsService.deleteSchoolById = async (adminSchoolId, schoolId) =>
  await fetch(`${schoolsEndpointPrefix}/${adminSchoolId}/school/${schoolId}`, {
    method: "DELETE",
  });

export default SchoolsService;
